export interface ReleaseNote {
  version: string;
  changes: string[];
  date: string;
}
